import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container mt-3 pb-5" }
const _hoisted_2 = { class: "ledger-state float-end" }
const _hoisted_3 = {
  key: 0,
  class: "badge alert-primary border-primary border shadow-sm"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("small", {
  style: {"font-size":"0.6em"},
  class: "pe-2"
}, "Ledger", -1)
const _hoisted_5 = { class: "text-primary" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" XRPL Pathfinding Demo ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "h5 fw-normal my-4" }, " This sample VueJS (TS, Vue3) project shows how easy it is to use pathfinding on the XRP Ledger, obtaining a list of assets and amounts to send to deliver a specific amount of another asset. ", -1)
const _hoisted_8 = { class: "card mb-3 shadow-sm" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, [
    /*#__PURE__*/_createTextVNode(" As soon as this page is loaded a WebSocket connection will be made using the "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.npmjs.com/package/xrpl-client",
      target: "_blank"
    }, [
      /*#__PURE__*/_createElementVNode("code", null, "xrpl-client")
    ]),
    /*#__PURE__*/_createTextVNode(" package to the public nodes of "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://xrplcluster.com/",
      target: "_blank"
    }, [
      /*#__PURE__*/_createElementVNode("code", null, "xrplcluster.com")
    ]),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Enter an activated XRP Ledger account (r...) on ")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", null, "mainnet", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(". Preferably an account with multiple Trust Lines setup, because cross asset path finding is a lot of fun. ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Now select a source account. Same applies here: preferably an account with multiple Trust Lines setup, because cross asset path finding is a lot of fun.")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Where the magic happens... (Spoiler alert: on the XRPL DEX). This is where we ask the XRP Ledger to find us the assets & their amount we can use to satisfy delivering the selected destination asset & amount.")
const _hoisted_16 = {
  key: 1,
  class: "d-flex align-items-center mt-4"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("strong", null, "Connecting to the XRP Ledger...", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border ms-auto",
  role: "status",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "py-2" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://github.com/WietseWind/Vue-Pathfinding-Demo" }, "Source code"),
  /*#__PURE__*/_createTextVNode(" by "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://wietse.com" }, "Wietse")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccountAndCurrencyPicker = _resolveComponent("AccountAndCurrencyPicker")!
  const _component_PathFinder = _resolveComponent("PathFinder")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.ready.ledger && _ctx.lastLedger !== '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("code", _hoisted_5, _toDisplayString(_ctx.lastLedger), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_6
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("h5", {
        class: _normalizeClass(["card-header", { 'text-white bg-success': _ctx.ready.ledger && _ctx.lastLedger !== '' }])
      }, " 1. XRP Ledger connection ", 2),
      _hoisted_9
    ]),
    (_ctx.ready.ledger && _ctx.lastLedger !== '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_AccountAndCurrencyPicker, {
            step: "2",
            accountTypeLabel: "destination account, asset and amount",
            xrpl: _ctx.xrpl,
            ready: _ctx.destinationReady
          }, {
            default: _withCtx(() => [
              _hoisted_11,
              _hoisted_12,
              _hoisted_13
            ]),
            _: 1
          }, 8, ["xrpl", "ready"]),
          (_ctx.ready.destination)
            ? (_openBlock(), _createBlock(_component_AccountAndCurrencyPicker, {
                key: 0,
                step: "3",
                accountTypeLabel: "source account",
                xrpl: _ctx.xrpl,
                ready: _ctx.sourceReady
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }, 8, ["xrpl", "ready"]))
            : _createCommentVNode("", true),
          (_ctx.ready.destination && _ctx.ready.source)
            ? (_openBlock(), _createBlock(_component_PathFinder, {
                key: 1,
                xrpl: _ctx.xrpl,
                params: _ctx.pathfindingParams
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              }, 8, ["xrpl", "params"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_19)),
    _hoisted_20
  ]))
}